import { render, staticRenderFns } from "./TrustSignalGroups.vue?vue&type=template&id=37ae5a9c&"
import script from "./TrustSignalGroups.vue?vue&type=script&lang=js&"
export * from "./TrustSignalGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports